var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(0 0)",
    fill: "#fefbe8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,1A17,17,0,0,0,5.979,30.021,17,17,0,0,0,30.021,5.979,16.889,16.889,0,0,0,18,1m0-1A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    transform: "translate(0 0)",
    fill: "#e5b357"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.872,0C14.652,0,16.2,1.6,16.2,4.347h0v9.3c0,2.79-1.548,4.356-4.328,4.356H4.329C1.593,18,0,16.434,0,13.644H0v-9.3A3.964,3.964,0,0,1,4.329,0h7.543Zm-7.3,12.366A.706.706,0,0,0,3.9,12.7a.715.715,0,0,0,0,.756.7.7,0,0,0,.675.324h7.056a.711.711,0,0,0,0-1.413H4.572Zm7.056-4.1H4.572a.7.7,0,0,0,0,1.4h7.056a.7.7,0,0,0,0-1.4ZM7.262,4.185H4.572v.009a.7.7,0,1,0,0,1.4h2.69a.707.707,0,0,0,0-1.413Z",
    transform: "translate(0)",
    fill: "#efb041"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocYellow);
export default __webpack_public_path__ + "static/media/doc_yellow.1d5a0a2f4c91290b076733c3b4480a35.svg";
export { ForwardRef as ReactComponent };